class VwHastaUyarilisteDTO {
    id: number = 0;
    kimlikId?: number = null;
    tckimlikno?: number = null;
    pasaportno?: string = "";
    ad?: string = "";
    soyad?: string = "";
    babaad?: string = "";
    fkIslem: number = 1;
    fkGrup?: number = null;
    aciklama?: string = "";
    aktif?: string = "E";
    eklemeTarihi?: string = null;
    ekleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    kullanici?: string = "";
}
export default VwHastaUyarilisteDTO;